import React, { useRef, useEffect } from 'react';
import { StyleSheet, SafeAreaView, Switch, Platform, useWindowDimensions } from 'react-native';
import CustomQuestionOptions from '../QuestionOptions/CustomQuestionOptions';
import CustomAnalytics from '../Analytics/CustomAnalytics';
import CustomButton from '../../CustomButton/CustomButton';
import CustomDropDown from '../../CustomDropDown/CustomDropdown';
import CustomInput from '../../CustomInput/CustomInput';
import CustomLabel from '../../CustomLabel/CustomLabel';
import { useTheme } from '@react-navigation/native';
import { useTranslation } from 'react-i18next';



const CustomQuestion = ({ handleQuestionChange, textFieldQuestionName, questionIndex, sectionId, sectionIndex, handleQuestionTypeChange, handleQuestionRatingOptionRemove, handleQuestionRatingOptionAdd, handleQuestionRatingOptionChange,
    input_type_name, allow_mutiple_option_answers_yn, question_required_yn, questionName, questionOption, handleQuestionOptionAdd, handleQuestionOptionChange,
    handleQuestionOptionRemove, chartOptions, chartData, noOfUsers, questionId, questionOptionResponseList
    , isResponse = 0, isResult = 0, isAnalytics = 0 }) => {

    var qId;
    const nameList = useRef([]);
    const agreeDisagreeArray = [1, 2, 3, 4, 5]
    const { t } = useTranslation();
    const { width, height } = useWindowDimensions();

    // TODO: This is not defined in the Database, hardcoding for now for Marital Status 
    const questionTypeList = [
        { label: t('common:text'), value: 'Text' },
        { label: t('common:Rating5'), value: 'Rating(5)' },
        { label: t('common:Rating10'), value: 'Rating(10)' },
        { label: t('common:Slider'), value: 'Slider' },
        { label: t('common:trueFalseOptions'), value: 'True/False Options' },
        { label: t('common:ratingOptions'), value: 'Rating Options' },
        { label: t('common:options'), value: 'Options' },
    ];
    const { colors } = useTheme()
    const styles = makeStyles(colors, width, height)

    useEffect(
        () => {
            // * No need to do anything here
        },
        [width, height]
    );
    return (
        <SafeAreaView
            style={styles.main}>
            <SafeAreaView
                style={styles.widthDirection}>
                {/* Question Name */}
                <SafeAreaView
                    style={isResponse ? styles.fullWidth : styles.seventyWidth}>
                    {/* //* The name of the textfield must match the name of the field representing this */}
                    <CustomInput
                        value={questionName === "" ? "" : questionName}
                        editable={isResponse == 1 ? false : true}
                        setValue={(e) => handleQuestionChange(e, questionIndex, sectionId, sectionIndex)}
                        type='SURVEYHEADER2'
                        placeholder={questionName === "" ? 'Write a Question' : questionName}
                        multiline={isResponse == 1}
                        scrollEnabled={isResponse == 1}
                    />
                </SafeAreaView>
                {/* Create Survey Question Customizations, allow multiple answers change quesiton type */}
                {!isResponse &&
                    <SafeAreaView
                        style={styles.dropDownView}>
                        <CustomDropDown
                            defValue={input_type_name}
                            options={questionTypeList}
                            value={input_type_name}
                            setValue={(e) => handleQuestionTypeChange(e, questionIndex, sectionIndex)}
                            type='FULL'
                        />
                        {(input_type_name === "Options") &&
                            <SafeAreaView
                                style={styles.row}>
                                <Switch
                                    checked={allow_mutiple_option_answers_yn ? true : false}
                                    onChange={(e) => handleQuestionChange(e, questionIndex, sectionId, sectionIndex, 1, 0)}
                                    name="allowMultipleAnswers" />
                                <CustomLabel
                                    value={t('common:allowedMultiple')}
                                    type='LEAVEDETAILSMINOR' />
                            </SafeAreaView>
                        }
                        {/* Create Survey Question Customizations, set if question is required */}
                        <SafeAreaView>
                            <SafeAreaView
                                style={styles.row}>
                                <Switch
                                    trackColor={{ false: '#767577', true: '#81b0ff' }}
                                    thumbColor={question_required_yn ? '#f5dd4b' : '#f4f3f4'}
                                    ios_backgroundColor="#3e3e3e"
                                    onValueChange={(e) => handleQuestionChange(e, questionIndex, sectionId, sectionIndex, 0, 1)}
                                    value={question_required_yn}
                                />
                                <CustomLabel
                                    value={t('common:requiredQuestion')}
                                    type='LEAVEDETAILSMINOR' />
                            </SafeAreaView>

                        </SafeAreaView>
                    </SafeAreaView>

                }
            </SafeAreaView>
            <SafeAreaView
                style={styles.ninentyWidth}>
                <SafeAreaView
                    style={(Platform.OS === 'web' && input_type_name === "Options") ? styles.radioDirectionCenter : styles.main}>
                    {(isResponse && !isAnalytics && input_type_name === "Rating Options") ?
                        questionOption.map((singleQuestion, index) => {
                            return (index % 6 === 0 &&
                                // This is the Subquestion title CustomQuestionOption
                                <SafeAreaView key={index} style={Platform.OS === 'web' && styles.centerMe}>
                                    <SafeAreaView style={styles.seventyWidth}>
                                        <CustomQuestionOptions
                                            input_type_name={input_type_name}
                                            handleQuestionOptionChange={handleQuestionOptionChange}
                                            question_option_id={singleQuestion.id}
                                            questionOptionResponseList={questionOptionResponseList}
                                            question_option_name={singleQuestion.question_option_name}
                                            allow_mutiple_option_answers_yn={allow_mutiple_option_answers_yn}
                                            handleQuestionRatingOptionChange={handleQuestionRatingOptionChange}
                                            questionId={questionId}
                                            isResponse={isResponse}
                                            isResult={isResult}
                                            sectionIndex={sectionIndex}
                                            questionIndex={questionIndex}
                                            index={index}
                                        />
                                    </SafeAreaView>
                                    {/* Agree Disagree Render */}
                                    <SafeAreaView
                                        style={styles.radioDirection}>
                                        {agreeDisagreeArray.map((adItr) => {
                                            return (
                                                <SafeAreaView
                                                    key={adItr + index}>
                                                    <CustomQuestionOptions
                                                        input_type_name={input_type_name}
                                                        handleQuestionOptionChange={handleQuestionOptionChange}
                                                        question_option_id={questionOption[adItr + index].id}
                                                        questionOptionResponseList={questionOptionResponseList}
                                                        question_option_name={questionOption[adItr + index].question_option_name}
                                                        allow_mutiple_option_answers_yn={allow_mutiple_option_answers_yn}
                                                        handleQuestionRatingOptionChange={handleQuestionRatingOptionChange}
                                                        questionId={questionId}
                                                        isResponse={isResponse}
                                                        isResult={isResult}
                                                        sectionIndex={sectionIndex}
                                                        questionIndex={questionIndex}
                                                        index={adItr + index}
                                                    />
                                                </SafeAreaView>)
                                        })}
                                    </SafeAreaView>
                                </SafeAreaView>)
                        })
                        :
                        questionOption.map((singleQuestion, index) => {
                            // * Rest of the Question Options
                            return ((!(!isResponse && (index % 6 !== 5)) &&
                                <SafeAreaView key={index}>
                                    {!isAnalytics ?
                                        <CustomQuestionOptions
                                            input_type_name={input_type_name}
                                            handleQuestionOptionChange={handleQuestionOptionChange}
                                            question_option_id={singleQuestion.id}
                                            questionOptionResponseList={questionOptionResponseList}
                                            question_option_name={singleQuestion.question_option_name}
                                            allow_mutiple_option_answers_yn={allow_mutiple_option_answers_yn}
                                            handleQuestionRatingOptionChange={handleQuestionRatingOptionChange}
                                            questionId={questionId}
                                            isResponse={isResponse}
                                            isResult={isResult}
                                            sectionIndex={sectionIndex}
                                            questionIndex={questionIndex}
                                            index={index}
                                        /> : null

                                    }
                                    {/* //#region For Create or Edit */}
                                    {!isResponse && (input_type_name === "Rating Options") ?
                                        <SafeAreaView className="customButtonRight" style={{ marginLeft: '75%' }}>
                                            {questionOption.length !== 6 && index % 6 === 5 && (
                                                <CustomButton
                                                    onPress={() => handleQuestionRatingOptionRemove(index, sectionIndex, questionIndex)}
                                                    iconName='trash-outline'
                                                    show='HOME_BELL'
                                                    type='HOME_BELL'
                                                    textTop='0'
                                                    sz={30}
                                                />
                                            )}
                                        </SafeAreaView>
                                        : (!isResponse && (input_type_name !== "Rating Options") &&
                                            <SafeAreaView className="customButtonRight" style={{ marginLeft: '75%' }}>
                                                {questionOption.length !== 1 && (
                                                    <CustomButton
                                                        onPress={() => handleQuestionOptionRemove(index, sectionIndex, questionIndex)}
                                                        iconName='trash-outline'
                                                        show='HOME_BELL'
                                                        type='HOME_BELL'
                                                        textTop='0'
                                                        sz={30}
                                                    />
                                                )}
                                            </SafeAreaView>)
                                    }
                                    {!isResponse && (input_type_name === "Options" || input_type_name === "True/False Options") ?
                                        <SafeAreaView className="customButton">
                                            {/* //* Limit the number of sections, when maximum section number is reached the button disappears   */}
                                            {questionOption.length - 1 === index && questionOption.length < 10 && (
                                                <CustomButton
                                                    ButtonType="2"
                                                    setClickListener={() => handleQuestionOptionAdd(index, sectionIndex, questionIndex, questionId)}
                                                    buttonName={"Add"}
                                                />

                                            )}
                                        </SafeAreaView> : null
                                    }
                                    {!isResponse && (input_type_name === "Rating Options") ?
                                        <SafeAreaView
                                            style={styles.twentyFiveWidth}>
                                            {/* //* Limit the number of sections, when maximum section number is reached the button disappears   */}
                                            {questionOption.length - 1 === index && questionOption.length < 60 && (
                                                <CustomButton
                                                    text={Platform.OS === 'web' && width > 1300 ? t('common:addAgreeDisagreeOption') : ''}
                                                    onPress={() => handleQuestionRatingOptionAdd(index, sectionIndex, questionIndex, questionId)}
                                                    iconName='add-outline'
                                                    show='SURVEY'
                                                    type='SURVEY'
                                                    textTop='0'
                                                    sz={25}
                                                />
                                            )}
                                        </SafeAreaView> : null
                                    }
                                    {/* //#endregion */}
                                </SafeAreaView>
                            )
                            )
                        })}
                </SafeAreaView>

                {/* Show Analytics */}
                {isAnalytics === 1 ?
                    <SafeAreaView
                        style={styles.center}>
                        <CustomAnalytics
                            chartOptions={chartOptions}
                            chartData={chartData}
                            noOfUsers={noOfUsers}
                            questionIndex={questionIndex}
                            questionName={questionName}
                            questionOptionResponseList={questionOptionResponseList}
                            input_type_name={input_type_name}
                            questionId={questionId}
                            question_option_id={qId}
                            questionOption={questionOption}
                            question_option_name={nameList.current}
                        /></SafeAreaView>
                    : null

                }
            </SafeAreaView>
        </SafeAreaView>
    );
};

const makeStyles = (colors, width, height) => StyleSheet.create({
    main: {
        flex: 1,
    },
    cardstyle: {
        padding: 10,
        margin: 10,
        borderRadius: 35,
        backgroundColor: colors.background_card,
    },
    dropDownView: {
        flex: 1,
        alignSelf: 'center',
        justifyContent: 'center'
    },
    ninentyWidth: {
        width: '90%',
        alignSelf: 'center'
    },
    seventyWidth: {
        width: '70%',
        alignSelf: 'center'
    },
    twentyFiveWidth: {
        width: '25%',
    },
    fullWidth: {
        flex: 1,
        flexWrap: 'wrap',
        alignSelf: 'center'
    },
    row: {
        flex: 1,
        flexDirection: 'row',
        margin: 10,
        justifyContent: 'space-evenly',
    },
    widthDirection: {
        margin: 10,
        justifyContent: 'space-between',
        flex: 1,
        flexDirection: (Platform.OS === 'web' && width > 800) ? 'row' : 'column',
    },
    centerMe: {
        flex: 1,
        alignContent: 'center',
        alignItems: 'center'
    },
    center: {

        paddingBottom:10,
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center'
    },

    radioDirection: {
        flex: 1,
        marginRight: (Platform.OS === 'web' && width > 1300) ? 0 : '20%',
        flexDirection: (Platform.OS === 'web' && width > 1300) ? 'row' : 'column',
    },

    radioDirectionCenter: {
        flex: 1,
        justifyContent: 'center',
        flexDirection: (Platform.OS === 'web' && width > 1300) ? 'row' : 'column',
    },
});

export default CustomQuestion;